"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var DownloadModalFooter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DownloadModalFooter, _PureComponent);

  function DownloadModalFooter() {
    (0, _classCallCheck2.default)(this, DownloadModalFooter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DownloadModalFooter).apply(this, arguments));
  }

  (0, _createClass2.default)(DownloadModalFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canSubmit = _this$props.canSubmit,
          onCancel = _this$props.onCancel,
          onSubmit = _this$props.onSubmit;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Button.default, {
        type: "default",
        onClick: onCancel
      }, "Cancel"), _react.default.createElement(_Button.default, {
        disabled: !canSubmit,
        type: "primary",
        onClick: onSubmit
      }, "Download"));
    }
  }]);
  return DownloadModalFooter;
}(_react.PureComponent);

exports.default = DownloadModalFooter;
(0, _defineProperty2.default)(DownloadModalFooter, "propTypes", {
  canSubmit: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  onSubmit: _propTypes.default.func
});